import images from '@assets/images/index'
import { MovePlayersPlayerWithTeamInfo } from 'src/types/type'

function PopOverContent(student: MovePlayersPlayerWithTeamInfo) {
  const { firstName, lastName, userId, idNumber, altUser } = student
  return (
    <ul className="data-list">
      <li className="data-list-item">
        <span className="data-list-item__icon">
          <images.User />
        </span>
        <span className="text-chalkboard-txt data-list-item__key">
          Player Name:
        </span>
        <span className="data-list-item__value text-chalkboard-txt fw-bold">
          {firstName ? firstName + (lastName || '') : 'None'}
        </span>
      </li>
      <li className="data-list-item">
        <span className="data-list-item__icon">
          <images.Hashtag />
        </span>
        <span className="text-chalkboard-txt data-list-item__key">
          District User ID:
        </span>
        <span className="data-list-item__value text-chalkboard-txt fw-bold">
          {altUser || 'None'}
        </span>
      </li>
      <li className="data-list-item">
        <span className="data-list-item__icon">
          <images.Hashtag />
        </span>
        <span className="text-chalkboard-txt data-list-item__key">
          District Identifier:
        </span>
        <span className="data-list-item__value text-chalkboard-txt fw-bold">
          {idNumber || 'None'}
        </span>
      </li>
      <li className="data-list-item">
        <span className="data-list-item__icon">
          <images.Hashtag />
        </span>
        <span className="text-chalkboard-txt data-list-item__key">
          First in Math User ID:
        </span>
        <span className="data-list-item__value text-chalkboard-txt fw-bold">
          {userId || 'None'}
        </span>
      </li>
    </ul>
  )
}

export default PopOverContent
